import cx from 'classnames'
import omit from 'lodash/omit'
import { FC, HTMLAttributes, ReactNode, useState } from 'react'

import CustomAccordionItem from './CustomAccordionItem'

import * as styles from './CustomAccordion.scss'

interface AccordionItemInterface extends Omit<HTMLAttributes<HTMLDivElement>, 'content'> {
  label: ReactNode
  content: ReactNode
  containerHeaderClassName?: string
  contentClassName?: string
  labelClassName?: string
  disabled?: boolean
  onOpen?: (isOpen: boolean) => void
}

export interface CustomAccordionProps {
  items: AccordionItemInterface[]
  singleOpened?: boolean
  values?: number[]
  setValues?: (indexes: number[]) => void
}

const CustomAccordion: FC<CustomAccordionProps> = ({
  items,
  singleOpened,
  values: openedIndexesProp,
  setValues: setOpenedIndexesProp,
}) => {
  const [openedIndexState, setOpenedIndexState] = useState<number[]>([])

  const openedIndex = openedIndexesProp || openedIndexState
  const setOpenedIndex = setOpenedIndexesProp || setOpenedIndexState

  const handleToggleOpen = (index: number, item: AccordionItemInterface) => {
    if (item.disabled) return
    const isOpened = openedIndex.includes(index)
    if (singleOpened) {
      setOpenedIndex(isOpened ? [] : [index])
      item.onOpen?.(!isOpened)
    } else {
      setOpenedIndex(isOpened ? openedIndex.filter(i => i !== index) : [...openedIndex, index])
      item.onOpen?.(!isOpened)
    }
  }

  return (
    <div className={styles.CustomAccordion} data-testid="custom-accordion">
      {items.map((item, index) => {
        const isOpen = openedIndex.includes(index)

        return (
          <CustomAccordionItem
            key={index}
            item={{
              ...omit(item, ['onOpen']),
              containerHeaderClassName: cx(
                { [styles.HeaderWithBorderTop]: item },
                { [styles.HeaderWithBorderBottom]: index === items.length - 1 && !isOpen },
                item.containerHeaderClassName,
              ),
            }}
            handleToggleOpen={() => handleToggleOpen(index, item)}
            isOpen={isOpen}
          />
        )
      })}
    </div>
  )
}

export default CustomAccordion
